<template>
    <Modal
        v-model="modal"
        :title="obj.title"
        @on-ok="ok"
        @on-cancel="cancel">
        <div class="content">
            <Icon size="20" class="warn-color" type="md-warning"></Icon>
            {{ obj.content }}
        </div>
    </Modal>
</template>
<script>
export default {
    name: 'RemoveDialog',
    props: {
        obj: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            modal: false
        }
    },
    watch: {
        'obj.isShow': function () {
            this.modal = this.obj.isShow
        }
    },
    methods: {
        ok() {
            this.$emit('closeDialog', 'confirm')
        },
        cancel() {
            this.$emit('closeDialog')
        }
    }
}
</script>
